"use client";

import { useTheme } from "@/lib/theme/them-provider";
import { useLocale } from "@/lib/locale/locale-provider";
import type { GiftParticipant } from "@/lib/sections/gifts.types";

type Props = {
  participants: GiftParticipant[];
  currency: string;
};

export function GiftParticipantsList({ participants, currency }: Props) {
  const { theme } = useTheme();
  const locale = useLocale();
  const emptyLabel =
    locale === "fr"
      ? "Aucune contribution enregistree pour le moment."
      : locale === "en"
        ? "No contributions yet."
        : "Noch keine Beitraege eingetragen.";
  const heading =
    locale === "fr"
      ? "Deja enregistre"
      : locale === "en"
        ? "Already added"
        : "Bereits eingetragen";
  const peopleLabel =
    locale === "fr"
      ? "participant(s)"
      : locale === "en"
        ? "guest(s)"
        : "Person(en)";

  if (!participants.length) {
    return (
      <div style={{ color: theme.colors.textMuted, lineHeight: 1.6 }}>
        {emptyLabel}
      </div>
    );
  }

  return (
    <div style={{ display: "grid", gap: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <strong style={{ color: theme.colors.text }}>{heading}</strong>
        <span style={{ color: theme.colors.textMuted, fontSize: 12 }}>
          {participants.length} {peopleLabel}
        </span>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        {participants.map((p, idx) => (
          <div
            key={`${p.createdAt}-${idx}`}
            style={{
              background: "white",
              borderRadius: 14,
              padding: "10px 12px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
              display: "flex",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            <div>
              <div style={{ fontWeight: 800, color: theme.colors.text }}>{p.name}</div>
              {p.note && (
                <div style={{ color: theme.colors.textMuted, fontSize: 13, marginTop: 2 }}>
                  {p.note}
                </div>
              )}
            </div>

            {typeof p.amount === "number" && (
              <div style={{ color: theme.colors.primary, fontWeight: 900, whiteSpace: "nowrap" }}>
                {p.amount.toFixed(0)} {currency}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
